import { render, staticRenderFns } from "./batchPrintBillStyleTwo.vue?vue&type=template&id=241053eb&scoped=true&"
import script from "./batchPrintBillStyleTwo.vue?vue&type=script&lang=js&"
export * from "./batchPrintBillStyleTwo.vue?vue&type=script&lang=js&"
import style0 from "./batchPrintBillStyleTwo.vue?vue&type=style&index=0&id=241053eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241053eb",
  null
  
)

export default component.exports